export const SUPPORTED_LOCALES = ['en-US'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en-US';

const SUPPORTED_LOCALES_LOWER = SUPPORTED_LOCALES.map((locale) => locale.toLowerCase());

const normalizeLocale = (locale?: string) => {
  if (!locale) return null;

  const lowerLocale = locale.toLowerCase();
  const exactMatchIndex = SUPPORTED_LOCALES_LOWER.indexOf(lowerLocale);

  if (exactMatchIndex >= 0) {
    return SUPPORTED_LOCALES[exactMatchIndex];
  }

  const baseTag = lowerLocale.split('-')[0];
  const partialMatchIndex = SUPPORTED_LOCALES_LOWER.findIndex((supported) => supported.startsWith(baseTag));

  return partialMatchIndex >= 0 ? SUPPORTED_LOCALES[partialMatchIndex] : null;
};

export const detectLocale = (preferred?: string | string[]): Locale => {
  const requestedLocales: string[] = [];

  if (preferred) {
    if (Array.isArray(preferred)) {
      requestedLocales.push(...preferred);
    } else {
      requestedLocales.push(preferred);
    }
  }

  if (typeof navigator !== 'undefined') {
    const browserLocales = [...(navigator.languages ?? []), navigator.language].filter(Boolean);
    requestedLocales.push(...browserLocales);
  }

  for (const locale of requestedLocales) {
    const normalized = normalizeLocale(locale);

    if (normalized) {
      return normalized;
    }
  }

  return DEFAULT_LOCALE;
};
